import { Machine } from "xstate";
import TeamModule from "@/store/modules/team.module";
import { toaster } from "@/utilities/toaster";
const viewTeamMachine = Machine({
    id: "viewTeam",
    context: {
        teamId: "",
    },
    initial: "idle",
    states: {
        idle: {
            always: {
                target: "gettingTeam",
            },
        },
        gettingTeam: {
            invoke: {
                id: "gettingTeam",
                src: (context, event) => TeamModule.ViewTeamById(context.teamId),
                onDone: { target: "teamLoaded" },
                onError: { target: "error" },
            },
        },
        teamLoaded: {
            on: {
                ADDING_GROUP: { target: "addGroup" },
                EDIT_GROUP: { target: "editGroup" },
                DELETE_GROUP: { target: "deleteGroup" },
                VIEW_GROUP: { target: "viewingGroup" },
            },
        },
        addGroup: {
            on: {
                SAVING_GROUP: { target: "addingGroup" },
                CANCEL_GROUP: { target: "teamLoaded" },
            },
        },
        addingGroup: {
            invoke: {
                id: "addingGroup",
                src: (context, event) => TeamModule.saveGroup(event.payload),
                onDone: { target: "gettingTeam", actions: ["showSuccessMessage"] },
                onError: { target: "addGroup" },
            },
        },
        editGroup: {
            on: {
                SAVING_GROUP: { target: "updatingGroup" },
                CANCEL_GROUP: { target: "teamLoaded" },
            },
        },
        updatingGroup: {
            invoke: {
                id: "updatingGroup",
                src: (context, event) => TeamModule.saveGroup(event.payload),
                onDone: { target: "gettingTeam", actions: ["showSuccessMessage"] },
                onError: { target: "editGroup" },
            },
        },
        deleteGroup: {
            tags: "showDeleteGroupUI",
            on: {
                DELETING_GROUP: { target: "deletingGroup" },
                CANCEL_GROUP: { target: "teamLoaded" },
            },
        },
        deletingGroup: {
            tags: "showDeleteGroupUI",
            invoke: {
                id: "deletingGroup",
                src: (context, event) => TeamModule.DeleteGroupById(event.groupId),
                onDone: { target: "gettingTeam", actions: ["showSuccessMessage"] },
                onError: { target: "deleteGroup" },
            },
        },
        viewingGroup: {
            on: {
                CANCEL_GROUP: { target: "teamLoaded" },
            },
        },
        error: {
            type: "final",
        },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
    },
    guards: {},
    activities: {},
    services: {
        delayedSuccess: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve({ result: true });
            }, 2000);
        }),
        delayedFailure: (_, __) => new Promise((resolve, reject) => {
            setTimeout(() => {
                reject({ result: false });
            }, 2000);
        }),
    },
});
export default viewTeamMachine;
